
import { i18nText } from '@/locales';

import { Component, Vue } from "vue-property-decorator";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { ITableColumn } from "@/entity/table/table.types";
import { TablesStore } from "@/store/modules/Tables";
import DrawerWrapper from "@/UI/components/common/DrawerWrapper.vue";
import WorkerDetail from "@/UI/components/workerDetail/WorkerDetail.vue";
import ModalWrapper from "@/UI/components/common/ModalWrapper.vue";
import { checkUserRole } from '@/router/Lib/helper';
import StaffAddFormComponent from "@/UI/components/forms/Staff/StaffAddFormComponent.vue";
import StaffUpdateFormComponent from "@/UI/components/forms/Staff/StaffUpdateFormComponent.vue";
import WorkerAddForm from "@/form/workerAdd/workerAdd";
import StaffUpdateForm from "@/form/staff/StaffUpdate";
import { WorkersStore } from "@/store/modules/Workers";
import { IWorkers, IWorkersListItem } from "@/entity/workers/workers.types";
import { WORKER_STATUS } from "@/utils";
import { CategoryStore } from "@/store/modules/Category";
import { StatusesStore } from "@/store/modules/Status";
import { PositionStore } from "@/store/modules/Position";
import { IPosition } from "@/entity/position/position.types";
import { IStatus } from "@/entity/status/status.types";
import { SalaryStore } from "@/store/modules/Salary";
import { ISalaryScheme } from "@/entity/salaryScheme/salaryScheme.types";
import { message } from "ant-design-vue";
import { ICms_Category } from '@/entity/staff/staff.types'
import { ProxyGetData } from "../Helpers/getData";
import { mixins } from "vue-class-component";
import { FormMix } from "@/UI/mixins/FormMix";
import { PaginationMix } from "@/UI/mixins/PaginationMix";
import { appPaginationStore } from "@/store/modules/appPagination";
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue";
import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue";

@Component({
    components: {
        StaffAddFormComponent,
        StaffUpdateFormComponent,
        ModalWrapper,
        WorkerDetail,
        DrawerWrapper,
        PageTitle,
        SortComponent,
        FilterTableComponent
    }
})
export default class SalonWorkers extends mixins(
    ProxyGetData
) {
    initialWorkerTab = this.$route.query.workerTab === 'schedule' ? 2 : 0;
    staffFilters = {fio: '', phone: '', status_id: undefined as number | undefined, position_id: [] as number[]};
    clearEmptyStaffFilter(field: 'fio' | 'phone'): void {
        if (!this.staffFilters[field]) this.applyStaffFilters();
    }
    async applyStaffFilters(): Promise<void> {
        this.proxyFilter = {salon_id: Number(this.$route.params.id), status: 'all',
            ...(this.staffFilters.fio.trim() ? {fio: this.staffFilters.fio.trim()} : {}),
            ...(this.staffFilters.phone.trim() ? {phone: this.staffFilters.phone.replace(/\D/g, '')} : {}),
            ...(this.staffFilters.status_id ? {status_id: this.staffFilters.status_id} : {}),
            ...(this.staffFilters.position_id.length ? {position_ids: this.staffFilters.position_id.join(',')} : {})};
        this.pager.current = 1;
        await this.getData();
    }
    form = new WorkerAddForm();
    updateForm = new StaffUpdateForm();
    workerStatuses = WORKER_STATUS;
    worker: IWorkersListItem | null = null;
    showAddModal = false;
    showUpdateModal = false;
    visible = false;
    customRow = (record: IWorkersListItem) => {
        return {
            on: {
                click: (event: any) => {
                    let target = event.target;
                    if (target.nodeName != 'BUTTON') {
                        this.show(record)
                    }
                }
            }
        };
    }

    get salonWorkersColumns(): ITableColumn[] {
        return TablesStore.salonWorkersColumns;
    }

    get staffLoaded(): boolean {
        return WorkersStore.workersLoaded;
    }

    get staff(): IWorkers | null {
        return WorkersStore.workers;
    }

    get positions(): IPosition[] {
        return PositionStore.position;
    }

    get statuses(): IStatus[] {
        return StatusesStore.status;
    }

    get categories(): ICms_Category[] {
        return CategoryStore.category;
    }

    get salary(): ISalaryScheme[] {
        return SalaryStore.salary;
    }

    show(staff: IWorkersListItem): void {
        this.worker = staff;
        this.visible = true;
    }

    handleAddModal(visible: boolean): void {
        if (!this.showAddModal) {
            this.showAddModal = visible;
        } else {
            if (this.form.fio
                || this.form.phone
                || this.form.position_id
                || this.form.description
                || this.form.salary) {
                let confirm = window.confirm(i18nText("Закрыть форму редактирования без сохранения?"));
                if (confirm) {
                    this.showAddModal = visible;
                }
            } else {
                this.showAddModal = visible;
            }
        }
    }

    handleUpdateModal(visible: boolean): void {
        this.showUpdateModal = visible;
        this.updateForm.setFormData(this.positions, this.categories, this.statuses, this.salary, this.worker);
    }

    async deleteWorker(id: number): Promise<void> {
        const response = await WorkersStore.delete(id)
        if (response.status) {
            message.success(i18nText("Сотрудник успешно удален"));
            await WorkersStore.fetchAll({ limit: 10, filter: { salon_id: parseInt(this.$route.params.id) } });
            this.$notification.success({
                message: i18nText("Сотрудник успешно удален"),
                description: response["response"],
                duration: 0,
            });
        } else {
            message.error(i18nText("Что то пошло не так..."))
            this.$notification.error({
                message: i18nText("Ошибка"),
                description: response["response"],
                duration: 0,
            })
        }
    }

    async submit(): Promise<void> {
        if (await this.form.submit(WorkersStore.create)) {
            await WorkersStore.fetchAll({ limit: 10, filter: { salon_id: parseInt(this.$route.params.id), status: 'all' } })
            this.form = new WorkerAddForm();
            this.form.setFormData(this.positions, this.categories, this.statuses, this.salary, +this.$route.params.id);
            this.showAddModal = false;
        }
    }

    async updateSubmit(): Promise<void> {
        if (await this.updateForm.submit(WorkersStore.update)) {
            await WorkersStore.fetchAll({ limit: 10, filter: { salon_id: parseInt(this.$route.params.id), status: 'all' } });
            this.showUpdateModal = false;
            if (this.staff && this.staff.data) {
                if (this.worker) {
                    for (let i = 0; i < this.staff.data.length; i++) {
                        if (this.worker.id == this.staff.data[i].id) {
                            this.worker = this.staff.data[i];
                            break;
                        }
                    }
                }
            }
            this.updateForm = new StaffUpdateForm();
        }
    }

    async created(): Promise<void> {
        appPaginationStore.setCurrent(1)

        this.proxyFilter = {
            salon_id: parseInt(this.$route.params.id),
            status: 'all'
        }
        await this.sortedData("asc", { dataIndex: "last_name" });
        await StatusesStore.fetchAll();
        await CategoryStore.fetchAll();
        await PositionStore.fetchAll();
        if (checkUserRole() === 'admin') await SalaryStore.fetchAll();
        this.form.setFormData(this.positions, this.categories, this.statuses, this.salary, +this.$route.params.id);
    }

    async onClose(): Promise<void> {
        this.visible = false;
        this.worker = null;
        if (WorkersStore.workers && WorkersStore.workers.total !== null) {
            appPaginationStore.setTotal(WorkersStore.workers.total)
            await this.sortedData("asc", { dataIndex: "last_name" });
        };
    }

    onWorkerEdit(): void {
        this.handleUpdateModal(this.visible);
    }

    onWorkerDelete(): void {
        if (this.worker) {
            this.deleteWorker(this.worker.id);
            this.onClose();
        }
    }
}
